import React, { useState, memo } from 'react';
import Modal from '@components/common/Modal';
import FullWidthModal from '../common/Modal/FullWidthModal';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import cn from 'classnames';
import style from './checksCommon.module.scss';
import { TouchableButton } from '../common/Touchable/index';

const MergeChecksModal = (props) => {

  // Props Destructuring
  const {
    isMergeCheckOpen,
    OpenChecksData,
    handleMergeOpen,
    onClose,
    currentCheckId,
    serverAppTheme,
    checkData,
    setConfirmationModal,
    confirmationModal,
    seats,
    setErrorPopUp,
  } = props;

  // State Management
  const openChecksList = Object.values(OpenChecksData);
  const [selectedCheck, setSelectedCheck] = useState([]);
  // Methods
  const handleItems = (data) => {
    let a = [];
    if (selectedCheck.includes(data.id)) {
      a = selectedCheck.filter((id) => id !== data.id);
    } else {
      a.push(...selectedCheck, data.id)
    }
    setSelectedCheck(a)
  }

  const MergeSelectedChecks = () => {
    if (selectedCheck.length == 0) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().MERGE_CHECK_ERROR,
        noErrorTxt: true
      })
    } else {
      setConfirmationModal(true)
    }
  }

  const stationName = checkData?.stationName?.length > 8 ? checkData?.stationName?.substring(0, 8).concat('...') : checkData.stationName;

  // HTML CSS CODE
  return (
    <>
      <FullWidthModal isOpen={isMergeCheckOpen} isModalCenter={true} customClass={cn('h-100')} customClass2='h-100 w-100' customWidth={true} style={{ backgroundColor: serverAppTheme?.popUp_bg, height: '100%' }}>
        <div className={cn('col-12 px-0 pb-1 position-relative h-100')} style={{ color: serverAppTheme?.primary_text }}>
          <div className={cn('col-12 fw-600 fs_18 d-flex py-1 px-2', style.moretitlebg)}>
            <div className={cn('fw-600 col-4 p-0' , props.isOrderingPortrait ? 'fs_16' : 'fs_18')}>{seats?.tab ? 'Tab' : 'Table'} : {stationName}</div>
            <div className='col-4 p-0 text-center'>Merge Check</div>
            <div className={cn('fw-600 col-4 p-0 text-right',props.isOrderingPortrait ? 'fs_16' : 'fs_18')}># {checkData?.number}</div>
          </div>
          <div className={cn('fw-600 text-center pt-3 fs_18')}>{LABEL().MERGE_CHECK_TITLE}</div>
          <div className={cn(props.isOrderingPortrait ? 'h-80 px-12 pt-3' : 'h-73 px-3 pt-2')}>
            <div id="table-container" className={cn("col-12 fs_16 fw-400 mx-auto justify-content-center overflowY px-0")} style={{ border: serverAppTheme?.popupBorderMerge, borderRadius: '5px', maxHeight: '100%' }}>

              <div className={cn('d-flex m-0', style.stickyHeader , props.isOrderingPortrait ? 'py-12' : '')} style={{ borderBottom: serverAppTheme?.popupBorderMerge, height: !props.isOrderingPortrait ? '28px' : '', backgroundColor: serverAppTheme?.popUp_bg }}>
                <div className={cn('col-1 px-0 text-center')} style={{ fontWeight: '400' }}></div>
                <div className={cn('col-3 px-0 text-left')} style={{ fontWeight: '400' }}>{LABEL().TABLE}</div>
                <div className={cn('col-2 px-0 text-left')} style={{ fontWeight: '400' }}>#</div>
                <div className={cn('col-4 px-0 text-left')} style={{ fontWeight: '400' }}>{LABEL().EMP}</div>
                <div className={cn('col-2 px-0 text-left' ,props.isOrderingPortrait ? 'pl-3' : '')} style={{ fontWeight: '400' }}>{LABEL().TOTAL}</div>
              </div>
              {openChecksList && openChecksList?.filter((item) => item.id !== currentCheckId).map((item) => {
                return (
                  <div className={cn('d-flex m-0 align-items-center', style.scrollableBody)} key={item.id} style={{ backgroundColor: selectedCheck.includes(item.id) ? serverAppTheme?.receipt_select_bg : '', borderBottom: serverAppTheme?.popupBorderMerge, height: '48px', padding: '0.75rem 0 0.75rem 0' }}>
                    <div className={cn('col-1 px-0 text-center d-flex align-items-center justify-content-center')}>
                      <input
                        type="checkbox"
                        id={item.id}
                        onChange={() => { }}
                        className={cn(props.isOrderingPortrait ? style.verticalmodemergecheckbox : style.mergecheckCheckbox)}
                        style={{
                          width: '1.25rem', height: '1.25rem', cursor: 'pointer', border: !(selectedCheck.includes(item.id)) && `2px solid ${serverAppTheme?.primary_text}`, '--checkbox-checked-color': serverAppTheme?.checkbox_check_color, '--checkbox-checked-bg': serverAppTheme?.checkbox_checked, '-webkit-appearance': 'none',
                          appearance: 'none'
                        }}
                        onClick={(e) => handleItems(item)}
                        checked={selectedCheck.includes(item.id)}
                      />
                    </div>
                    <div className={cn('col-3 text-left text-truncate',props.isOrderingPortrait ? 'pl-1 fs_12 fw-400' :'pl-0')} style={{ paddingRight: '26px' }}>{item.stationName ? item.stationName : item.stationNumber}</div>
                    <div className={cn('col-2 text-left',props.isOrderingPortrait ? 'pr-2 pl-0 fs_12 fw-400' : 'px-0')}>{item.number}</div>
                    <div className={cn('col-4 px-0 text-left' , props.isOrderingPortrait ? `${style.employeeName} fs_12 fw-400`  : '')}>{item.employeeFirstName + " " + item.employeeLastName}</div>
                    <div className={cn('col-2 px-0 text-left',props.isOrderingPortrait ? 'fs_12 px-3 fw_400' : '')}  >{LABEL().CURRENCY_SYMBOL + item.totalAmount.toFixed(2)}</div>
                  </div>);
              })}
            </div>
          </div>
          <div className={cn('d-flex  pt-2 pb-3' , !props.isOrderingPortrait ? 'justify-content-center' : 'px-12')}>
            <div className={cn('pr-1' ,props.isOrderingPortrait ?'col-6 pl-0' : 'col-5')}>
              <TouchableButton type="button" className={cn('px-0 rounded btn-ripple fs_24 fw-600 w-100',props.isOrderingPortrait ? 'btn68' : 'btn44')} onClick={(e) => { e.preventDefault(); onClose() }} style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }}>
                {LABEL().CANCEL}
              </TouchableButton>
            </div>
            <div className={cn('pl-1',props.isOrderingPortrait ? 'col-6 pr-0' : 'col-5')}>
              <TouchableButton type="submit" className={cn('btn-ripple fw-600 w-100  d-flex align-items-center justify-content-center' ,props.isOrderingPortrait ? 'btn68 fs_28' : 'btn44 fs_24')} style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color, height:!props.isOrderingPortrait ?'8.5vh' : '', opacity: 1 }} onClick={() => MergeSelectedChecks()}><span className='fw-600 w-100'>{LABEL().TABLE_MERGE}</span></TouchableButton>
            </div>
          </div>
        </div>
      </FullWidthModal>
      <Modal isOpen={confirmationModal} isModalCenter={true} noBackground style={{ width:props.isOrderingPortrait ? '490px' : '418px', minHeight: '222px', border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, backgroundColor: serverAppTheme?.popUp_bg, borderRadius: '16px', margin: 'auto' }}>
        <div className="col-12 my-4 justify-content-center align-items-center position-relative text-center" style={{ color: serverAppTheme?.primary_text }}>
          <div className="col-12 fs_18 mt-10 fw-700 text-center">
            <div>Are you sure?</div>
          </div>
          <div className="col-12 fs_15 mt-10 fw-400 text-center">
            <div>{CUSTOM_MESSAGES().MERGE_OPEN_CHECKS_CONFIRMATION_MSG}</div>
          </div>
          <div className="col-12 mt-4 d-flex justify-content-center">
            <TouchableButton
              type="submit"
              className={cn(style.noBtn, "col-6 my-2 mx-0 btn44")}
              onClick={() => { setConfirmationModal(false); }}
              style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }}
            >
              <div className="fs_24 fw-600">{LABEL().NO}</div>
            </TouchableButton>
            <TouchableButton
              type="submit"
              className={cn(style.yesBtn, "col-6 m-2 btn44")}
              onClick={() => { handleMergeOpen(selectedCheck); }}
              style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
            >
              <div className="fs_24 fw-600">{LABEL().YES}</div>
            </TouchableButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default memo(MergeChecksModal);